module.exports = __webpack_public_path__ + "static/media/question.5e223ee9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/question.svg
// module id = 169
// module chunks = 1